import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    clienteId: 0,
    clienteNombre: '',

    id: 0,
    nombre: '',
    telefono: '',
    celular: '',
    whatsapp: '',
    email: '',
    email2: '',
    fechaNacimientoDia: 0,
    fechaNacimientoMes: 0,
    fechaNacimientoMesNombre: null,
    fechaNacimientoAnio: 0,
    inactivo: false,
    rowVersion: null,

    contactoDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_CONTACTO' (state, params) {
        state.id = params.id;
        state.clienteId = params.clienteId;
        state.clienteNombre = '';

        state.nombre = '';
        state.telefono = '';
        state.celular = '';
        state.whatsapp = '';
        state.email = '';
        state.email2 = '';
        state.fechaNacimientoDia = 0;
        state.fechaNacimientoMes = 0;
        state.fechaNacimientoMesNombre = null;
        state.fechaNacimientoAnio = 0;
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_CLIENTE'(state, clienteNombre) {
        state.clienteNombre = clienteNombre;
    },
    'SET_CONTACTO' (state, contacto) {
        state.clienteNombre = contacto.clienteNombre.toUpperCase().trim();

        state.nombre = contacto.nombre.toUpperCase().trim();
        state.telefono = contacto.telefono;
        state.celular = contacto.celular;
        state.whatsapp = contacto.whatsapp;
        state.email = contacto.email;
        state.email2 = contacto.email2;
        state.fechaNacimientoDia = contacto.fechaNacimientoDia;
        state.fechaNacimientoMes = contacto.fechaNacimientoMes;
        state.fechaNacimientoMesNombre = helpers.methods.getMesNombre(contacto.fechaNacimientoMes);
        state.fechaNacimientoAnio = contacto.fechaNacimientoAnio;
        state.inactivo = contacto.inactivo;
        state.rowVersion = contacto.rowVersion;
    },
    'SET_CONTACTO_ID' (state, contacto) {
        state.id = contacto.id;
        state.rowVersion = contacto.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.contactoDatos = [];
    },
    'SET_DATOS'(state, params) {
        state.contactoDatos = params.contactoDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CONTACTO', params);
            
            let contactoId = 0;
            if (params.id) {
                if (params.id != 0) {
                    contactoId = params.id;
                }
            }

            if (contactoId != 0) {
                apiAxios.get('clientescontactos/' + params.id + '/abm' ) 
                .then(res => {
                    commit('SET_CONTACTO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));                
            } else {
                apiAxios.get('clientes/' + params.clienteId)
                .then(res => {
                    commit('SET_CLIENTE', res.data.nombreComercial);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));                
            }
        }, error => {
            reject(error);
        })            
    },
    save ( { state, commit } ) {
        return new Promise((resolve, reject) => {
            /*
            let fechaNacimiento = '1900-01-01';
            if ((/true/i).test(state.fechaNacimientoHabilitada)) {
                fechaNacimiento = moment(state.fechaNacimiento).format('YYYY-MM-DD');
            }
            */

            let contacto= {
                clienteId: state.clienteId,
                nombre: state.nombre.toUpperCase().trim(),
                telefono: state.telefono.toUpperCase().trim(),
                celular: state.celular.toUpperCase().trim(),
                whatsapp: state.whatsapp.toUpperCase().trim(),
                email: state.email.toLowerCase().trim(),
                email2: state.email2.toLowerCase().trim(),
                fechaNacimientoDia: parseInt(state.fechaNacimientoDia), 
                fechaNacimientoMes: helpers.methods.getMesNumero(state.fechaNacimientoMesNombre), 
                fechaNacimientoAnio: parseInt(state.fechaNacimientoAnio), 
                inactivo: state.inactivo,
            }

            let url = 'clientescontactos';
            if (state.id != 0) {
                url += "/" + state.id;
                contacto.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, contacto)
                .then(res => {
                    /* Actualizamos Id y RowVersion */
                    commit('SET_CONTACTO_ID', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    inactivar ( { }, contactoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('clientescontactos/' + contactoId + '/inactivar')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getDatos ( { commit }, contactoId ) {
        return new Promise((resolve, reject) => {

            commit('INICIALIZAR_DATOS');
            
            if (contactoId) {
                if (contactoId != 0) {
                    apiAxios.get('clientescontactos/' + contactoId ) 
                    .then(res => {

                        let dia = res.data.fechaNacimientoDia.toString();
                        dia = dia.padStart(2, '0');
                        let mes = res.data.fechaNacimientoMes.toString();
                        mes = mes.padStart(2, '0');
                        let anio = res.data.fechaNacimientoAnio.toString();
                        anio = anio.padStart(4, '0');
                        
                        let fechaNacimiento = dia + "/" + mes + "/" + anio;
                        if (anio == '0000')
                            fechaNacimiento = dia + "/" + mes;

                        let contactoDatos = [
                            { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'clienteNombre', 'campo': 'Cliente', 'valor': res.data.clienteNombre, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'telefono', 'campo': 'Teléfono', 'valor': res.data.telefono, 'formato': '' },
                            { 'nombre': 'celular', 'campo': 'Celular', 'valor': res.data.celular, 'formato': '' },
                            { 'nombre': 'email', 'campo': 'Email', 'valor': res.data.email, 'formato': '' },
                            { 'nombre': 'email2', 'campo': 'Email', 'valor': res.data.email2, 'formato': '' },
                            { 'nombre': 'fechaNacimiento', 'campo': 'Fecha Nacim.', 'valor': fechaNacimiento, 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo) ? 'Si' : 'No', 'formato': '' },
                        ];
                        
                        let params = {
                            contactoDatos
                        };

                        commit('SET_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));                    
                }
            } 
        }, error => {
            reject(error);
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}